import { animationEvents } from "./animation-events.js";
import { caseResultsEvents } from "./case-result-events.js";
import { faqEvents } from "./faq-events.js";
import { formEvents } from "./form/form-events.js";
import { navEvents } from "./nav-events.js";
import { sliderEvents } from "./new-slider/slider-events.js";
import { sellingPointsEvents } from "./selling-points-events.js";
import { sidebarEvents } from "./sidebar-events.js";
import { videoEvents } from "./video-events.js";

document.addEventListener("DOMContentLoaded", () => {
	navEvents();
	animationEvents();
	sliderEvents(); // i could go even further and look for these elements before dynamically importing events
	sellingPointsEvents(); // i could go even further and look for these elements before dynamically importing events
	sidebarEvents(); //  i could go even further and look for these elements before dynamically importing events
	faqEvents();
	formEvents();
	if (document.querySelector(".ilawyer-case-results")) caseResultsEvents();
	// only run videos on the page that are not in a slider. slider videos load sliderVideoEvents() after slider init in cloned-slides.js
	const videos = document.querySelectorAll("div:not([data-acf-template]) > .ilawyer-video");
	videoEvents(videos); //  i could go even further and look for these elements before dynamically importing events
});
